import { Button } from "@/components/Button/Button";
import { Icon } from "@/components/Icon";
import * as gtag from "@/lib/gtag";
import Link from "next/link";
import { PageContext } from "pages/[[...slug]]";
import React, { useContext } from "react";
import ButtonPhone from "@/components/ButtonPhone/ButtonPhone";

const highlights = [
  "10 Jahre Kögler Garantie inklusive",
  "Kostenlose Lieferung",
];

const CtaSection = ({ className = "", link, includeLinkText }) => {
  const { config } = useContext(PageContext);

  const links = ["/10-jahre-garantie/", "/kostenlose-lieferung/"];
  return (
    <div
      className={`container w-full flex lg:flex-nowrap flex-wrap justify-between items-center ${className} `}
    >
      <div className="w-[44%]"></div>

      <div className="xl:w-1/4 lg:w-[22%] w-full lg:mt-0 mt-6 order-1 lg:order-none">
        <ButtonPhone
          className="lg:!text-sm xl:!text-2xl hd:!text-3xl whitespace-nowrap"
          size="fullwidth"
          config={config}
          itemPosition="below"
        />
      </div>
      <div className="xl:w-1/4 lg:w-[22%] w-full lg:mt-0 mt-6 ">
        <Button
          size="fullwidth"
          as="a"
          rel="nofollow"
          className="cursor-pointer lg:!text-sm xl:!text-2xl hd:!text-3xl"
          href={link}
          onClick={() => {
            gtag.event({
              event: "itemClick",
              itemClick: "Request",
              itemPosition: "above",
            });
          }}
        >
          <Icon type="mail" className="w-6 h-6 mr-4" />
          Kauf anfragen
        </Button>
      </div>
    </div>
  );
};

export default CtaSection;
